import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Dashboard from '@/components/Dashboard'
import Admin from '@/components/admin/Admin'
import Login from '@/components/admin/Login'
import DashboardTV from '@/components/tv/DashboardTV'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: Admin
    },
    {
      path: '/admin/:id',
      name: 'Admin',
      component: Admin,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:id',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/tv/:id',
      name: 'Dashboard TV',
      component: DashboardTV
    },
    {
      path: '/:id/:pane',
      name: 'Dashboard Pane',
      component: Dashboard
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser
  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js